module.exports = __webpack_public_path__ + "static/title-graphic-4d46349711d4b371a994f1b9c904693e.svg";